import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';

export function WATCHER__generation_reset_token_list_add_lora_tag() {
  const dispatch = use_dispatch();

  const { global__page_type, g_general__layout } = use_slice_ui(['global__page_type', 'g_general__layout']);
  const { generation_current } = use_slice_generation(['generation_current']);

  use_effect(() => {
    if (generation_current.is_stub() || generation_current.status != ENUM__generation_status.ADJUSTING) {
      dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_general__field_to_add_special_tokens', field: FIELD__list_token.CREATE_STUB() }));
    }
  }, [generation_current]);

  use_effect(() => {
    if (global__page_type.includes(ENUM__page_type.GENERATION_WITHOUT_PARAMS)) return; //no need to reset

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_general__field_to_add_special_tokens', field: FIELD__list_token.CREATE_STUB() }));
  }, [global__page_type]);

  use_effect(() => {
    //on any layout change - reset field
    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_general__field_to_add_special_tokens', field: FIELD__list_token.CREATE_STUB() }));
  }, [g_general__layout]);

  return null;
}
